import { z } from 'zod';
/**
 * Справочник дополнительных услуг (страхование, таможня и т.п.). Управляется
 * админом; клиент выбирает активные услуги в поручении.
 */
export const serviceCatalogCreateSchema = z.object({
    name: z.string().min(1).max(200),
    sortOrder: z.number().int().optional(),
});
export const serviceCatalogPatchSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
export const serviceCatalogItemSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    isActive: z.boolean(),
    sortOrder: z.number().int(),
});
//# sourceMappingURL=service-catalog.js.map